import gql from 'graphql-tag'

export const CREATE_WORKSHOP = gql`
  mutation CreateWorkshop($eventId: ID!, $workshopData: WorkshopInput!) {
    createWorkshop(workshopData: $workshopData, eventId: $eventId) {
      id
    }
  }
`
export const DELETE_WORKSHOP = gql`
  mutation DeleteWorkshop($eventId: ID!, $workshopId: ID!) {
    deleteWorkshop(eventId: $eventId, workshopId: $workshopId)
  }
`

export const GET_EVENT_WORKSHOPS = gql`
  query GetWorkshops($eventId: ID!, $includeBreaks: Boolean) {
    getWorkshops(eventId: $eventId, includeBreaks: $includeBreaks) {
      id
      name
      unlimitedAttendance
      attendanceLimit
      attending
      isBreak
      to
      from
      hall {
        id
        name
      }
    }
  }
`
export const GET_EVENT_WORKSHOP_AND_HALLS = gql`
  query GetWorkshop($eventId: ID!, $workshopId: ID!) {
    getHalls(eventId: $eventId){
      id
      name
    }
    getWorkshop(eventId: $eventId, workshopId: $workshopId) {
      id
      name
      hall {
        id
        name
      }
      lecturers {
        id
        fields
      }
      description
      unlimitedAttendance
      attendanceLimit
      feedbackEnabled
      to
      from
      event {
        id
        to
        from
        extraModules {
          mobileApp
          conferenceMobileApp
          expoMobileApp
        }
      }
      attendees {
        id, uuid, fields
      }
      attending
    }
  }
`

export const UPDATE_WORKSHOP = gql`
  mutation UpdateWorkshop($eventId: ID!, $workshopData: WorkshopUpdateInput!) {
    updateWorkshop(eventId: $eventId, workshopData: $workshopData)
  }
`

export const REMOVE_WORKSHOP_ATTENDEE = gql`
  mutation RemoveWorkshopAttendee($attendeeId: ID!, $workshopId: ID!, $eventId: ID!) {
    removeWorkshopAttendee(attendeeId: $attendeeId, workshopId: $workshopId , eventId: $eventId )
  }
`

// COR-1684: the conference app's talk feedback, read by the organiser. `total` and
// `average` are over the whole workshop, not over this page.
export const GET_WORKSHOP_FEEDBACK = gql`
  query GetWorkshopFeedback($eventId: ID!, $workshopId: ID!, $page: Int, $perPage: Int) {
    getWorkshopFeedback(eventId: $eventId, workshopId: $workshopId, page: $page, perPage: $perPage) {
      total
      average
      items {
        id
        rating
        comment
        createdAt
        attendee {
          id
          fields
          conferenceData {
            avatar
          }
        }
      }
    }
  }
`
